import React from "react";
import "./styles.css";

export default function RedesSociales() {
    return (
        <footer>
            <p style={{ marginTop: "15px" }}>&copy; Sublime Hair Salon</p>
            <div className="rounded-social-buttons">
                <a
                    className="social-button instagram"
                    href="https://www.instagram.com/sublimebarberia"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fab fa-instagram"></i>
                </a>
            </div>
        </footer>
    );
}
